import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  useMediaQuery,
  Dialog,
  DialogContent,
  Radio,
} from "@mui/material";
import { connect } from "react-redux";
import { homeActions } from "actions";
import RefillReminderPopUp from "./RefillReminderPopUp";
import SavedCouponPopUp from "./SavedCouponPopUp";
import DoseReminderPopUp from "./DoseReminderPopUp";
import SendTextMessagePopUp from "./SendTextMessagePopUp";
import SendEmailMessagePopUp from "./SendEmailMessagePopUp";
import MessageDialog from "./MessageDialog";
import RequestSignup from "./RequestSignup";
import ProductInfo from "./ProductInfo";
import ForwardToInbox from "assets/images/coupon-share.png";
import ShareHCPApp from "pages/home/ShareHCPApp";
import CouponQRCode from "../../components/CouponQRCode";

const CouponSaveButtonView = (props) => {
  const {
    genericDetails,
    saveCoupon,
    selectedInsurance,
    savedCouponInfo,
    resetSavedCouponInfo,
    deleteCoupon,
    deleteCouponInfo,
    resetDeleteCouponInfo,
    resetDoseReminderInfo,
    selectedGenericItem,
    appQuantity,
    resetRefillSavingsData,

    organizationInfo,
    getProfile,
    hideTextCouponIcon,
    updateGTMDataLayer,
    profileInfo,
    savedDoseReminderInfo,
    savedRefillReminderInfo,
    couponData = null,
    showShareHCPPopup = false,
    setShowShareHCPPopup = null,
    txtCouponBtnClass = "sticky-front",
    couponPrice,
  } = props;

  const [showRefill, setShowRefill] = useState(false);
  const [showSaveSignUp, setShowSaveSignUp] = useState(false);
  const [showRefillSignUpCheck, setShowRefillSignUpCheck] = useState(false);
  const [showReminderSignUpCheck, setShowReminderSignUpCheck] = useState(false);
  const [showDoseReminder, setShowDoseReminder] = useState(false);
  const [showSendTextMessage, setShowSendTextMessage] = useState(false);
  const [showSendEmailMessage, setShowSendEmailMessage] = useState(false);
  const [showProductInfo, setShowProductInfo] = useState(false);

  // const [successErrorTitle, setSuccessErrorTitle] = useState("");
  const [successErrorMessage, setSuccessErrorMessage] = useState("");
  const [showSuccessErrorDialog, setShowSuccessErrorDialog] = useState(false);
  const [showAlreadySavedDialog, setShowAlreadySavedDialog] = useState(false);
  const [isFromSavedCouponPopup, setIsFromSavedCouponPopup] = useState(false);
  const [showTextCoupon, setShowTextCoupon] = useState(false);
  const [textCouponType, setTextCouponType] = useState("text");

  const isLoggedIn = JSON.parse(sessionStorage.getItem("isLoggedIn"));
  const matches = useMediaQuery("(max-width:900px)");
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const [showShareHCPCouponPopupMessage, setShowShareCouponHCPPopupMessage] =
    useState(false);
  const [showShareHCPCouponPopupEmail, setShowShareCouponHCPPopupEmail] =
    useState(false);

     const isHCPTemplate =
       organizationInfo?.type?.toLowerCase() === "h" &&
       organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
     const widgetEnabled = sessionStorage.getItem("widgetEnabled");
     const [showQRCode, setShowQRCode] = useState(false);
  // useEffect(() => {
  //   const favPharGroupId = localStorage.getItem("pharmacyGroupId");
  //   if (favPharGroupId && favPharGroupId !== "null") {
  //     setTimeout(() => {
  //       let val = "";
  //       if (
  //         organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
  //         "y"
  //       ) {
  //         val = "text";
  //       } else if (
  //         organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
  //         "y"
  //       ) {
  //         val = "email";
  //       }
  //       if (val) {
  //         if (matches && !hideTextCouponIcon) {
  //           setShowTextCoupon(true);
  //         }
  //         radioBtnHandleChange(undefined, val);
  //       }
  //     }, 3000);
  //   }
  // }, []);

  const radioBtnHandleChange = (
    event,
    defaultVal = couponPrice?.qrCodeUrl ? "qrcode" : "text"
  ) => {
    const val = event?.target?.value || defaultVal;
    setTextCouponType(val);
    setShowSendTextMessage(false);
    setShowSendEmailMessage(false);
    setShowQRCode(false);
    if (val === "qrcode") {
      setShowQRCode(true);
    } else if (val === "text") {
      setShowSendTextMessage(true);
    } else if (val === "email") {
      setShowSendEmailMessage(true);
    } else {
      window.open(
        genericDetails?.pdfUrl,
        "_blank",
        "location=yes,height=570,width=1250, left=100, top=100, status=yes"
      );
      setShowTextCoupon(false);
    }
  };

  const radioControlProps = (item) => ({
    checked: textCouponType === item,
    onChange: radioBtnHandleChange,
    value: item,
    name: "location-type-radio-button",
    inputProps: { "aria-label": item },
  });

  useEffect(() => {
    return () => {
      resetSavedCouponInfo();
      resetDeleteCouponInfo();
      resetDoseReminderInfo();
      resetRefillSavingsData();
    };
  }, []);

  useEffect(() => {
    if (savedCouponInfo && savedCouponInfo.success) {
      setSuccessErrorMessage(savedCouponInfo.message);
      setShowSuccessErrorDialog(true);
    } else if (
      savedCouponInfo &&
      Object.keys(savedCouponInfo).length &&
      !savedCouponInfo.success
    ) {
      setShowSuccessErrorDialog(true);
      setSuccessErrorMessage(savedCouponInfo.message);
    }
  }, [savedCouponInfo]);

  useEffect(() => {
    if (deleteCouponInfo && deleteCouponInfo.success) {
      setSuccessErrorMessage(deleteCouponInfo.message);
      setShowSuccessErrorDialog(true);
    } else if (
      deleteCouponInfo &&
      Object.keys(deleteCouponInfo).length &&
      !deleteCouponInfo.success
    ) {
      setShowSuccessErrorDialog(true);
      setSuccessErrorMessage(deleteCouponInfo.message);
    }
  }, [deleteCouponInfo]);
 

  return (
    <>
      {matches && !hideTextCouponIcon && (
        <div id="sticky" className={txtCouponBtnClass || "sticky-front"}>
          <img
            alt="Text Coupon"
            onClick={() => {
              if (isHCPTemplate) {
                setShowShareHCPPopup(true);
              } else {
                setShowTextCoupon(true);
                couponData?.qrCodeUrl
                  ? setShowQRCode(true)
                  : setShowSendTextMessage(true);
                setTextCouponType(couponData?.qrCodeUrl ? "qrcode" : "text");
              }
            }}
            style={{ cursor: "pointer", width: "50%" }}
            src={ForwardToInbox}
          />
        </div>
      )}
      <Box>
        <Box sx={{ position: "relative", padding: matches ? "5px" : "19px" }}>
          <Box
            sx={{
              display: "flex",
              // flexDirection: matches ? "column" : undefined,
              justifyContent: matches ? "center" : "space-between",
              alignItems: matches ? "center" : undefined,
            }}
          >
            {!matches && !isHCPTemplate && (
              <>
                {organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
                  "y" && (
                  <Box
                    mb={matches ? 2 : undefined}
                    sx={{
                      width: matches ? "100%" : undefined,
                      marginRight: 1,
                    }}
                  >
                    <Button
                      variant="filled"
                      sx={{
                        minWidth: matches ? "100%" : undefined,
                        height: "100%",
                      }}
                      onClick={() => {
                        if (isHCPTemplate) {
                          setShowShareCouponHCPPopupMessage(true);
                        } else {
                          setShowSendTextMessage(true);
                        }
                      }}
                    >
                      <Typography variant="text3">Text</Typography>
                    </Button>
                  </Box>
                )}
                {organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
                  "y" && (
                  <Box
                    mb={matches ? 2 : undefined}
                    sx={{
                      width: matches ? "100%" : undefined,
                      marginRight: 1,
                    }}
                  >
                    <Button
                      variant="filled"
                      sx={{
                        minWidth: matches ? "100%" : undefined,
                        height: "100%",
                      }}
                      onClick={() => {
                        if (isHCPTemplate) {
                          setShowShareCouponHCPPopupEmail(true);
                        } else {
                          setShowSendEmailMessage(true);
                        }
                      }}
                    >
                      <Typography variant="text3">Email</Typography>
                    </Button>
                  </Box>
                )}
                {organizationInfo?.organizationOptionJson?.couponPrintFlag?.toLowerCase() ===
                  "y" && (
                  <Box
                    mb={matches ? 2 : undefined}
                    sx={{
                      width: matches ? "100%" : undefined,
                      marginRight: 1,
                    }}
                  >
                    <Button
                      variant="filled"
                      sx={{
                        minWidth: matches ? "100%" : undefined,
                        height: "100%",
                      }}
                      onClick={() =>
                        window.open(
                          genericDetails?.pdfUrl,
                          "_blank",
                          "location=yes,height=570,width=1250, left=100, top=100, status=yes"
                        )
                      }
                    >
                      <Typography variant="text3">Print</Typography>
                    </Button>
                  </Box>
                )}
              </>
            )}
            {widgetEnabled?.toLowerCase() === "n" &&
              organizationInfo?.organizationOptionJson?.saveCouponFlag?.toLowerCase() ===
                "y" && (
                <Box
                  mb={matches ? 2 : undefined}
                  sx={{
                    width: matches ? "21%" : undefined,
                    marginRight: 0.5,
                    height: matches ? "3.4rem" : undefined,
                  }}
                >
                  <Button
                    variant="filled"
                    sx={{
                      padding: matches ? "0px" : undefined,
                      minWidth: matches ? "100%" : undefined,
                      height: "100%",
                      border:
                        (savedCouponInfo?.data ||
                          savedDoseReminderInfo?.data ||
                          savedRefillReminderInfo?.data ||
                          genericDetails?.savedFlag === "Y" ||
                          genericDetails.doseReminderFlag === "Y" ||
                          genericDetails?.refillReminderFlag === "Y") &&
                        !deleteCouponInfo?.data
                          ? "2px solid #093d4c"
                          : "none",
                    }}
                    onClick={() => {
                      updateGTMDataLayer({
                        event: "Get_savings_save_coupons_attempt",
                        page: "Copay Coupon Card",
                        screen: "Copay Coupon Card",
                        screen_referrer: "Copay Coupon Card",
                        adjudicationId: genericDetails?.id,
                        action: "attempting coupon save",
                      });
                      if (isLoggedIn) {
                        if (
                          genericDetails?.savedFlag === "Y" ||
                          genericDetails.doseReminderFlag === "Y" ||
                          genericDetails?.refillReminderFlag === "Y"
                        ) {
                          setShowAlreadySavedDialog(true);
                        } else {
                          saveCoupon({
                            insuranceId: selectedInsurance?.id,
                            productDetailId: genericDetails?.productDetailId,
                            pharmacyLocationId:
                              selectedGenericItem?.pharmacyLocationId,
                            quantity: appQuantity,
                            couponType:
                              selectedGenericItem?.couponType ||
                              selectedGenericItem?.discountType,
                          });
                          resetDeleteCouponInfo();
                          setIsFromSavedCouponPopup(false);
                          updateGTMDataLayer({
                            event: "Get_savings_save_coupons",
                            action: "compelted coupon save",
                            page: "Copay Coupon Card",
                            screen: "Copay Coupon Card",
                            screen_referrer: "Copay Coupon Card",
                            insuranceId: selectedInsurance?.id,
                            productDetailId: genericDetails?.productDetailId,
                            pharmacyLocationId:
                              selectedGenericItem?.pharmacyLocationId,
                            quantity: appQuantity,
                            couponType:
                              selectedGenericItem?.couponType ||
                              selectedGenericItem?.discountType,
                          });
                        }
                      } else {
                        setShowSaveSignUp(true);
                      }
                    }}
                  >
                    <Typography
                      sx={{ fontSize: matches ? "12px" : undefined }}
                      variant="text3"
                    >
                      Save{matches ? <br /> : " "}Coupon
                    </Typography>
                  </Button>
                </Box>
              )}
            {widgetEnabled?.toLowerCase() === "n" &&
              organizationInfo?.organizationOptionJson?.doseReminderFlag?.toLowerCase() ===
                "y" && (
                <Box
                  mb={matches ? 2 : undefined}
                  sx={{
                    width: matches ? "21%" : undefined,
                    marginRight: 0.5,
                    height: matches ? "3.4rem" : undefined,
                  }}
                >
                  <Button
                    variant="filled"
                    sx={{
                      height: "100%",
                      paddingLeft: matches ? "0px" : undefined,
                      paddingRight: matches ? "0px" : undefined,
                      minWidth: matches ? "100%" : undefined,
                      border:
                        (savedDoseReminderInfo?.data ||
                          genericDetails.doseReminderFlag === "Y") &&
                        !deleteCouponInfo?.data
                          ? "2px solid #093d4c"
                          : "none",
                    }}
                    onClick={() => {
                      if (isLoggedIn) {
                        setShowDoseReminder(true);
                      } else {
                        setShowReminderSignUpCheck(true);
                      }
                    }}
                  >
                    <Typography
                      sx={{ fontSize: matches ? "12px" : undefined }}
                      variant="text3"
                    >
                      Daily Dose Reminder
                    </Typography>
                  </Button>
                </Box>
              )}
            {widgetEnabled?.toLowerCase() === "n" &&
              organizationInfo?.organizationOptionJson?.refillSavingsFlag?.toLowerCase() ===
                "y" && (
                <Box
                  mb={matches ? 2 : undefined}
                  sx={{
                    width: matches ? "21%" : undefined,
                    marginRight: 0.5,
                    height: matches ? "3.4rem" : undefined,
                  }}
                >
                  <Button
                    variant="filled"
                    sx={{
                      padding: matches ? "0px" : undefined,
                      paddingLeft: matches ? "0px" : undefined,
                      paddingRight: matches ? "0px" : undefined,
                      minWidth: matches ? "100%" : undefined,
                      height: "100%",
                      border:
                        (savedRefillReminderInfo?.data ||
                          genericDetails?.refillReminderFlag === "Y") &&
                        !deleteCouponInfo?.data
                          ? "2px solid #093d4c"
                          : "none",
                    }}
                    onClick={() => {
                      if (isLoggedIn) {
                        setShowRefill(true);
                        if (!profileInfo || !profileInfo.data) {
                          getProfile();
                        }
                      } else {
                        setShowRefillSignUpCheck(true);
                      }
                    }}
                  >
                    <Typography
                      sx={{ fontSize: matches ? "12px" : undefined }}
                      variant="text3"
                    >
                      Refill Savings
                    </Typography>
                  </Button>
                </Box>
              )}
            {widgetEnabled?.toLowerCase() === "n" &&
              organizationInfo?.organizationOptionJson?.productInfoFlag?.toLowerCase() ===
                "y" && (
                <Box
                  mb={matches ? 2 : undefined}
                  sx={{
                    width: matches ? "21%" : undefined,
                    marginRight: 0.5,
                    height: matches ? "3.4rem" : undefined,
                  }}
                >
                  <Button
                    variant="filled"
                    sx={{
                      minWidth: matches ? "100%" : undefined,
                      height: "100%",
                      padding: matches ? "0px" : undefined,
                    }}
                    onClick={() => setShowProductInfo(true)}
                  >
                    <Typography
                      sx={{ fontSize: matches ? "12px" : undefined }}
                      variant="text3"
                    >
                      Product Info
                    </Typography>
                  </Button>
                </Box>
              )}
          </Box>
        </Box>

        {showSaveSignUp ? (
          <RequestSignup
            onButtonClick={() => setShowSaveSignUp(false)}
            titleInfo={`Cuverd finds and saves free coupons that ${
              matchesMinWidth ? "" : "<br />"
            } work at your local pharmacy.`}
            showPopUp={showSaveSignUp}
          />
        ) : null}
        {showRefill ? (
          <RefillReminderPopUp
            onCancel={() => {
              setShowRefill(false);
              //refreshGenericData();
            }}
            showRefill={showRefill}
            selectedGenericItem={selectedGenericItem}
          />
        ) : null}

        {showRefillSignUpCheck ? (
          <RequestSignup
            onButtonClick={() => setShowRefillSignUpCheck(false)}
            titleInfo={`Get helpful refill savings reminders to keep you ${
              matchesMinWidth ? "" : "<br />"
            } on track by signing up for a Cuverd account.`}
            showPopUp={showRefillSignUpCheck}
          />
        ) : null}

        {showDoseReminder ? (
          <DoseReminderPopUp
            onCancel={() => {
              setShowDoseReminder(false);
              //refreshGenericData();
            }}
            showDoseReminder={showDoseReminder}
            selectedGenericItem={selectedGenericItem}
          />
        ) : null}

        {showReminderSignUpCheck ? (
          <RequestSignup
            onButtonClick={() => setShowReminderSignUpCheck(false)}
            titleInfo={`Cuverd can remind you when it’s ${
              matchesMinWidth ? "" : "<br />"
            } time to take your medication.`}
            showPopUp={showReminderSignUpCheck}
          />
        ) : null}

        {showTextCoupon && (
          <Dialog open={true} className="app-dialog" onClose={() => {}}>
            <DialogContent
              sx={{ textAlign: "center", padding: "15px 24px 0px 24px" }}
            >
              <Typography
                variant="h2LatoBold"
                sx={{
                  fontFamily: "Lato",
                  fontWeight: "bold",
                  paddingLeft: "5px",
                }}
              >
                {showSendTextMessage
                  ? "Text me coupon to show pharmacy"
                  : "Email me coupon to show pharmacy"}
              </Typography>
              <div style={{ marginLeft: "-8px" }}>
                {couponPrice?.qrCodeUrl && (
                  <>
                    <Radio {...radioControlProps("qrcode")} color="success" />
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        fontWeight: 500,
                        fontSize: 16,
                        textAlign: "center",
                        color: "#607277",
                      }}
                    >
                      QR Code
                    </Typography>
                  </>
                )}
                {organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
                  "y" && (
                  <>
                    <Radio {...radioControlProps("text")} color="success" />
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        fontWeight: 500,
                        fontSize: 16,
                        textAlign: "center",
                        color: "#607277",
                      }}
                    >
                      Text
                    </Typography>
                  </>
                )}
                {organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
                  "y" && (
                  <>
                    <Radio {...radioControlProps("email")} color="success" />
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        fontWeight: 500,
                        fontSize: 16,
                        textAlign: "center",
                        color: "#607277",
                      }}
                    >
                      Email
                    </Typography>
                  </>
                )}
                {organizationInfo?.organizationOptionJson?.couponPrintFlag?.toLowerCase() ===
                  "y" && (
                  <>
                    <Radio {...radioControlProps("print")} color="success" />
                    <Typography
                      variant="h2LatoMedium"
                      sx={{
                        fontWeight: 500,
                        fontSize: 16,
                        textAlign: "center",
                        color: "#607277",
                      }}
                    >
                      Print
                    </Typography>
                  </>
                )}
              </div>
            </DialogContent>
            {showQRCode && (
              <CouponQRCode
                popupContentOnly={true}
                onCancel={() => {
                  setShowQRCode(false);
                  setShowTextCoupon(false);
                }}
              />
            )}
            {showSendTextMessage && (
              <SendTextMessagePopUp
                showTextCoupon={showTextCoupon}
                showSendTextMessage={showSendTextMessage}
                onCancel={() => {
                  setShowSendTextMessage(false);
                  setShowTextCoupon(false);
                }}
              />
            )}
            {showSendEmailMessage && (
              <SendEmailMessagePopUp
                showTextCoupon={showTextCoupon}
                showSendEmailMessage={showSendEmailMessage}
                onCancel={() => {
                  setShowSendEmailMessage(false);
                  setShowTextCoupon(false);
                }}
              />
            )}
          </Dialog>
        )}

        {showSendTextMessage && !showTextCoupon && (
          <SendTextMessagePopUp
            showSendTextMessage={showSendTextMessage}
            onCancel={() => setShowSendTextMessage(false)}
          />
        )}

        {showProductInfo && (
          <ProductInfo
            productDetailId={genericDetails?.productDetailId}
            showProductInfo={showProductInfo}
            onCancel={() => setShowProductInfo(false)}
          />
        )}

        {showSendEmailMessage && !showTextCoupon && (
          <SendEmailMessagePopUp
            showSendEmailMessage={showSendEmailMessage}
            onCancel={() => setShowSendEmailMessage(false)}
          />
        )}

        {showSuccessErrorDialog ? (
          <MessageDialog showPopUp={showSuccessErrorDialog}>
            <Box mb={7}>
              <Typography variant="h2LatoHeavy">
                {successErrorMessage}
              </Typography>
            </Box>
            <Box>
              <Button
                variant="large"
                onClick={() => {
                  // resetDeleteCouponInfo();
                  // refreshGenericData();
                  setShowSuccessErrorDialog(false);
                }}
                sx={{ minWidth: { xs: "150px", sm: "150px", md: "100%" } }}
              >
                DONE
              </Button>
            </Box>
            {!isFromSavedCouponPopup ? (
              <Box mt={2}>
                <Button
                  variant="text"
                  onClick={() => {
                    // Here the type of data should be a number like
                    // data: 945, message: "This coupon has been saved."success: true
                    deleteCoupon(savedCouponInfo?.data);
                    setIsFromSavedCouponPopup(true);
                    setShowSuccessErrorDialog(false);
                    resetSavedCouponInfo();
                  }}
                  sx={{ minWidth: { xs: "150px", sm: "150px", md: "100%" } }}
                >
                  UNDO
                </Button>
              </Box>
            ) : null}
          </MessageDialog>
        ) : null}

        {showAlreadySavedDialog ? (
          <SavedCouponPopUp
            showPopUp={showAlreadySavedDialog}
            onDeleteClick={() => {
              setIsFromSavedCouponPopup(true);
              setShowAlreadySavedDialog(false);
              deleteCoupon(genericDetails?.savedCouponId);
            }}
            onCancelClick={() => setShowAlreadySavedDialog(false)}
          />
        ) : null}

        {(showShareHCPPopup ||
          showShareHCPCouponPopupEmail ||
          showShareHCPCouponPopupMessage) && (
          <ShareHCPApp
            setShowSharePopup={setShowShareHCPPopup}
            shareCoupon={showShareHCPPopup}
            setShowShareCouponHCPPopupMessage={
              setShowShareCouponHCPPopupMessage
            }
            showShareHCPCouponPopupMessage={showShareHCPCouponPopupMessage}
            setShowShareCouponHCPPopupEmail={setShowShareCouponHCPPopupEmail}
            showShareHCPCouponPopupEmail={showShareHCPCouponPopupEmail}
            shareApp={false}
            couponData={couponData}
          />
        )}
      </Box>
    </>
  );
};

function mapStateToProps(state) {
  return {
    genericDetails: state.genericDetails.data,
    selectedInsurance: state.insuranceList.selectedInsurance || {},
    savedCouponInfo: state.savedCouponInfo.data,
    deleteCouponInfo: state.deleteCouponInfo.data,
    savedDoseReminderInfo: state.savedDoseReminderInfo.data,
    savedRefillReminderInfo: state.savedRefillReminderInfo.data,
    appQuantity: state.productDetails.appQuantity,
    organizationInfo: state.organizationInfo.data,
    profileInfo: state.profile.profileData,
    couponPrice: state.couponPrice.data,
  };
}

const mapDispatchToProps = {
  getProfile: () => homeActions.getProfile(),
  resetData: (value) => homeActions.resetData(value),
  resetSavedCouponInfo: (value) => homeActions.resetSavedCouponInfo(value),
  saveCoupon: (params) => homeActions.saveCoupon(params),
  deleteCoupon: (value) => homeActions.deleteCoupon(value),
  resetDeleteCouponInfo: () => homeActions.resetDeleteCouponInfo(),
  resetDoseReminderInfo: () => homeActions.resetDoseReminderInfo(),
  resetRefillSavingsData: () => homeActions.resetRefillSavingsData(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouponSaveButtonView);
